import { render, staticRenderFns } from "./ProveedorFormulario.vue?vue&type=template&id=62218ec1&"
import script from "./ProveedorFormulario.vue?vue&type=script&lang=js&"
export * from "./ProveedorFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports